const navigationTabBlocks = document.querySelectorAll('.block-navigation-tabs');
const navigationDesktopBreakpoint = 1130;

const getTabButtonWrapper = (tab) => {
	return Array.from(tab.children).find((child) =>
		child.classList.contains('wp-block-button')
	);
};

const getTabButton = (tab) => {
	return getTabButtonWrapper(tab)?.querySelector('.wp-block-button__link');
};

const getTabPanels = (tab) => {
	return Array.from(tab.children).filter(
		(child) => !child.classList.contains('wp-block-button')
	);
};

const activateNavigationTab = (tabBlock, activeIndex) => {
	const tabs = tabBlock.querySelectorAll('.block-navigation-tab');
	const useAccordionTabs = window.innerWidth < navigationDesktopBreakpoint;

	tabs.forEach((tab, index) => {
		const isActive = index === activeIndex;
		const tabButtonWrapper = getTabButtonWrapper(tab);
		const tabButton = getTabButton(tab);
		const tabPanels = getTabPanels(tab);

		tab.classList.toggle('active', isActive);
		tabButtonWrapper?.classList.toggle('active', isActive);

		if (tabButton) {
			tabButton.setAttribute(
				'aria-selected',
				isActive ? 'true' : 'false'
			);
			tabButton.setAttribute(
				'tabindex',
				isActive || useAccordionTabs ? '0' : '-1'
			);
		}

		tabPanels.forEach((tabPanel) => {
			tabPanel.hidden = !isActive;
			tabPanel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
		});
	});
};

const getActiveTabIndex = (tabBlock) => {
	const tabs = Array.from(tabBlock.querySelectorAll('.block-navigation-tab'));
	const activeIndex = tabs.findIndex((tab) =>
		tab.classList.contains('active')
	);

	return -1 === activeIndex ? 0 : activeIndex;
};

const updateNavigationTabsResponsiveState = () => {
	navigationTabBlocks.forEach((tabBlock) => {
		activateNavigationTab(tabBlock, getActiveTabIndex(tabBlock));
	});
};

if (navigationTabBlocks.length) {
	navigationTabBlocks.forEach((tabBlock, blockIndex) => {
		const tabs = tabBlock.querySelectorAll('.block-navigation-tab');

		tabs.forEach((tab, index) => {
			const tabButtonWrapper = getTabButtonWrapper(tab);
			const tabButton = getTabButton(tab);
			const tabPanels = getTabPanels(tab);
			const tabId = `navigation-tab-${blockIndex}-${index}`;
			const panelId = `navigation-tab-panel-${blockIndex}-${index}`;

			tab.setAttribute('role', 'presentation');
			tabButtonWrapper?.classList.add('initialized');

			if (tabButton) {
				tabButton.setAttribute('id', tabButton.id || tabId);
				tabButton.setAttribute('role', 'tab');
				tabButton.setAttribute('aria-controls', panelId);

				tabButton.addEventListener('click', (e) => {
					e.preventDefault();
					activateNavigationTab(tabBlock, index);
				});
			}

			tabPanels.forEach((tabPanel, panelIndex) => {
				tabPanel.setAttribute(
					'id',
					tabPanel.id ||
						(0 === panelIndex
							? panelId
							: `${panelId}-${panelIndex}`)
				);
				tabPanel.setAttribute('role', 'tabpanel');

				if (tabButton) {
					tabPanel.setAttribute('aria-labelledby', tabButton.id);
				}
			});
		});

		activateNavigationTab(tabBlock, 0);
	});

	window.addEventListener('resize', updateNavigationTabsResponsiveState);
}
